import { render, staticRenderFns } from "./ProfilePolicyModal.vue?vue&type=template&id=48f313d2&"
import script from "./ProfilePolicyModal.vue?vue&type=script&lang=js&"
export * from "./ProfilePolicyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports